module.exports = __webpack_public_path__ + "static/media/p24.370b4660.png";